var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_9","name":"9","data-vcode":"NUMBER_9","aria-label":"9 WXYZ"}},[_c('div',{staticClass:"digit"},[_vm._v("9")]),_c('div',{staticClass:"letters"},[_vm._v("WXYZ")])])
}]

export { render, staticRenderFns }